// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "sensor_service.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Defines the SensorService service, and its request/response types
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SensorReading } from "./common";
import { Timestamp } from "./common";
import { SensorType } from "./common";
/**
 * @generated from protobuf message aeolus.proto.GetReadingsRequest
 */
export interface GetReadingsRequest {
    /**
     * / The Device ID to fetch sensor readings for
     *
     * @generated from protobuf field: string device_id = 1;
     */
    deviceId: string;
    /**
     * / The sensor type(s) to fetch readings for. If omitted, readings for all sensor types are returned
     *
     * @generated from protobuf field: repeated aeolus.proto.SensorType sensor_types = 2;
     */
    sensorTypes: SensorType[];
    /**
     * / The end time of the period of data points to fetch. This may be omitted, in which case it means "now"
     *
     * @generated from protobuf field: aeolus.proto.Timestamp endTime = 3;
     */
    endTime?: Timestamp;
    /**
     * / The period of data points to fetch (i.e. the first data point is not earlier than endTime - period). This may be
     * / zero, in which case a period of infinity is assumed
     *
     * @generated from protobuf field: uint64 period_ms = 4;
     */
    periodMs: bigint;
    /**
     * / The aggregation window to use. No more than 1 value will be returned for each aggregation window (with that value
     * / being the mean of the sensor readings which occurred in the aggregation window). E.g. for an aggregation window of
     * / 5 minutes, a maximum of 1 data point will be returned for each 5-minute interval. This may be zero, in which
     * / case no aggregation is performed and the raw data is returned
     *
     * @generated from protobuf field: uint64 aggregation_window_ms = 5;
     */
    aggregationWindowMs: bigint;
}
/**
 * @generated from protobuf message aeolus.proto.GetReadingsResponse
 */
export interface GetReadingsResponse {
    /**
     * @generated from protobuf field: repeated aeolus.proto.SensorReading readings = 1;
     */
    readings: SensorReading[];
}
/**
 * @generated from protobuf message aeolus.proto.StreamReadingsRequest
 */
export interface StreamReadingsRequest {
    /**
     * / The Device ID to stream sensor readings for
     *
     * @generated from protobuf field: string device_id = 1;
     */
    deviceId: string;
    /**
     * / The sensor type(s) to fetch readings for. If omitted, readings for all sensor types are returned
     *
     * @generated from protobuf field: repeated aeolus.proto.SensorType sensor_types = 2;
     */
    sensorTypes: SensorType[];
    /**
     * / The period of historic data to return, before starting to stream incoming data. If zero, no historic data is
     * / returned.
     *
     * @generated from protobuf field: uint64 initial_period_ms = 3;
     */
    initialPeriodMs: bigint;
}
/**
 * @generated from protobuf message aeolus.proto.StreamReadingsResponse
 */
export interface StreamReadingsResponse {
    /**
     * @generated from protobuf field: aeolus.proto.SensorReading reading = 1;
     */
    reading?: SensorReading;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetReadingsRequest$Type extends MessageType<GetReadingsRequest> {
    constructor() {
        super("aeolus.proto.GetReadingsRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sensor_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["aeolus.proto.SensorType", SensorType] },
            { no: 3, name: "endTime", kind: "message", T: () => Timestamp },
            { no: 4, name: "period_ms", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "aggregation_window_ms", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<GetReadingsRequest>): GetReadingsRequest {
        const message = { deviceId: "", sensorTypes: [], periodMs: 0n, aggregationWindowMs: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetReadingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReadingsRequest): GetReadingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* repeated aeolus.proto.SensorType sensor_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sensorTypes.push(reader.int32());
                    else
                        message.sensorTypes.push(reader.int32());
                    break;
                case /* aeolus.proto.Timestamp endTime */ 3:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* uint64 period_ms */ 4:
                    message.periodMs = reader.uint64().toBigInt();
                    break;
                case /* uint64 aggregation_window_ms */ 5:
                    message.aggregationWindowMs = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReadingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* repeated aeolus.proto.SensorType sensor_types = 2; */
        if (message.sensorTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sensorTypes.length; i++)
                writer.int32(message.sensorTypes[i]);
            writer.join();
        }
        /* aeolus.proto.Timestamp endTime = 3; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* uint64 period_ms = 4; */
        if (message.periodMs !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.periodMs);
        /* uint64 aggregation_window_ms = 5; */
        if (message.aggregationWindowMs !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.aggregationWindowMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetReadingsRequest
 */
export const GetReadingsRequest = new GetReadingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReadingsResponse$Type extends MessageType<GetReadingsResponse> {
    constructor() {
        super("aeolus.proto.GetReadingsResponse", [
            { no: 1, name: "readings", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => SensorReading }
        ]);
    }
    create(value?: PartialMessage<GetReadingsResponse>): GetReadingsResponse {
        const message = { readings: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetReadingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetReadingsResponse): GetReadingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated aeolus.proto.SensorReading readings */ 1:
                    message.readings.push(SensorReading.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetReadingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated aeolus.proto.SensorReading readings = 1; */
        for (let i = 0; i < message.readings.length; i++)
            SensorReading.internalBinaryWrite(message.readings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetReadingsResponse
 */
export const GetReadingsResponse = new GetReadingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamReadingsRequest$Type extends MessageType<StreamReadingsRequest> {
    constructor() {
        super("aeolus.proto.StreamReadingsRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sensor_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["aeolus.proto.SensorType", SensorType] },
            { no: 3, name: "initial_period_ms", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<StreamReadingsRequest>): StreamReadingsRequest {
        const message = { deviceId: "", sensorTypes: [], initialPeriodMs: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StreamReadingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamReadingsRequest): StreamReadingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* repeated aeolus.proto.SensorType sensor_types */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.sensorTypes.push(reader.int32());
                    else
                        message.sensorTypes.push(reader.int32());
                    break;
                case /* uint64 initial_period_ms */ 3:
                    message.initialPeriodMs = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamReadingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* repeated aeolus.proto.SensorType sensor_types = 2; */
        if (message.sensorTypes.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.sensorTypes.length; i++)
                writer.int32(message.sensorTypes[i]);
            writer.join();
        }
        /* uint64 initial_period_ms = 3; */
        if (message.initialPeriodMs !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.initialPeriodMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.StreamReadingsRequest
 */
export const StreamReadingsRequest = new StreamReadingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamReadingsResponse$Type extends MessageType<StreamReadingsResponse> {
    constructor() {
        super("aeolus.proto.StreamReadingsResponse", [
            { no: 1, name: "reading", kind: "message", T: () => SensorReading }
        ]);
    }
    create(value?: PartialMessage<StreamReadingsResponse>): StreamReadingsResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<StreamReadingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StreamReadingsResponse): StreamReadingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* aeolus.proto.SensorReading reading */ 1:
                    message.reading = SensorReading.internalBinaryRead(reader, reader.uint32(), options, message.reading);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StreamReadingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* aeolus.proto.SensorReading reading = 1; */
        if (message.reading)
            SensorReading.internalBinaryWrite(message.reading, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.StreamReadingsResponse
 */
export const StreamReadingsResponse = new StreamReadingsResponse$Type();
/**
 * @generated ServiceType for protobuf service aeolus.proto.SensorService
 */
export const SensorService = new ServiceType("aeolus.proto.SensorService", [
    { name: "GetReadings", options: {}, I: GetReadingsRequest, O: GetReadingsResponse },
    { name: "StreamReadings", serverStreaming: true, options: {}, I: StreamReadingsRequest, O: StreamReadingsResponse }
]);
